/**
 * VierBeinerGlück · Cart-Drawer Controller · Phase 1
 * ────────────────────────────────────────────────────────────────────
 * Öffnet den einfahrenden Warenkorb (sections/vbg-cart-drawer.liquid) beim
 * Klick aufs Header-Cart-Icon. Cart-Mutationen (Menge/Entfernen) laufen über
 * die Shopify Section-Rendering-API und tauschen #vbg-cd-contents live aus —
 * kein Full-Page-Reload.
 *
 * Add-to-Cart-Trigger + Inline-Upsell/Empfehlungen: Phase 2.
 * Vanilla JS, keine Abhängigkeiten.
 */
(function () {
  'use strict';

  var SECTION = 'vbg-cart-drawer';
  var root = document.getElementById('vbgCartDrawer');
  if (!root) return;

  var contents = root.querySelector('#vbg-cd-contents');
  var busy = false;
  var lastFocus = null;

  // ── Cart-API ────────────────────────────────────────────────
  function postChange(body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  // ── Contents aus Section-HTML tauschen ──────────────────────
  function swapFromHTML(html) {
    if (!html || !contents) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('#vbg-cd-contents');
    if (fresh) contents.innerHTML = fresh.innerHTML;
    // Panel-Breite an den frisch gerenderten Cart-Zustand koppeln: der
    // Empfehlungs-Flügel (--wide, 700px statt 420px) haengt vom Warenkorb ab.
    // Die Liquid-Klasse spiegelt nur den Zustand beim Seiten-Load — beim
    // dynamischen Öffnen/Refresh muss sie mitwandern, sonst quillt der breite
    // Inhalt aus dem schmalen Panel nach rechts aus dem Bild.
    var freshPanel = doc.querySelector('.vbg-cd__panel');
    var panel = root.querySelector('.vbg-cd__panel');
    if (freshPanel && panel) {
      panel.classList.toggle('vbg-cd__panel--wide', freshPanel.classList.contains('vbg-cd__panel--wide'));
    }
    animateShipBar();
  }

  // ── Free-Shipping-Bar: Fuell-Animation + Erfolgs-Moment ─────
  // Der Section-Swap rendert den Fill direkt auf Endbreite → keine Transition.
  // Wir merken den vorherigen Prozentwert (sessionStorage, ueberlebt Add-to-Cart
  // aus der PDP mit Drawer-Open) und animieren von alt → neu. Kippt der Balken
  // dabei ueber 100 %, zuenden wir den Gratis-Versand-Erfolgsmoment.
  var SHIP_KEY = 'vbgShipPct';
  function getPrevPct() {
    try { var v = sessionStorage.getItem(SHIP_KEY); return v == null ? null : parseFloat(v); } catch (e) { return null; }
  }
  function setPrevPct(v) { try { sessionStorage.setItem(SHIP_KEY, String(v)); } catch (e) {} }
  function animateShipBar() {
    var ship = contents.querySelector('.vbg-cd__ship');
    var fill = contents.querySelector('.vbg-cd__ship-fill');
    if (!ship || !fill) return;
    var target = parseFloat(fill.getAttribute('data-fill'));
    if (isNaN(target)) target = parseFloat(fill.style.width) || 0;
    var prev = getPrevPct();
    var from = (prev == null) ? target : prev;
    // Startbreite ohne Transition setzen, dann per rAF auf Ziel animieren
    fill.style.transition = 'none';
    fill.style.width = from + '%';
    void fill.offsetWidth; // Reflow erzwingen
    fill.style.transition = '';
    requestAnimationFrame(function () { fill.style.width = target + '%'; });
    // Gerade eben Gratis-Versand freigeschaltet? → nach der Fuellung feiern
    if (prev != null && prev < 100 && target >= 100) {
      setTimeout(function () { celebrateShipping(ship); }, 560);
    }
    setPrevPct(target);
  }
  // Erfolgsmoment: Textwechsel + Farbwechsel des Balkens. Mehr nicht.
  // Die Konfetti-Funktion (elf Punkte, vier rohe Hexwerte) ist am 2026-08-07
  // gefallen — die Begruendung steht im CSS-Block der Section.
  function celebrateShipping(ship) {
    if (!ship || !ship.classList) return;
    ship.classList.add('vbg-cd__ship--celebrate');
    setTimeout(function () { ship.classList.remove('vbg-cd__ship--celebrate'); }, 1500);
  }

  // ── Empfehlung hinzufügen ───────────────────────────────────
  function cartAddVariant(id, btn) {
    if (busy) return; busy = true;
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1, sections: SECTION, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (res) { applyCartResponse(res); scrollToLastItem(); try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {} })
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  // Nach Reco-Add: Scroll auf den zuletzt hinzugefügten Artikel (unten) + Empfehlungen,
  // statt nach dem Content-Swap oben zu springen.
  function scrollToLastItem() {
    var sc = root.querySelector('.vbg-cd__scroll');
    if (!sc) return;
    requestAnimationFrame(function () {
      var last = sc.querySelector('.vbg-cd__items .vbg-cd__item:last-child');
      if (last) {
        var top = last.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop - 12;
        try { sc.scrollTo({ top: top, behavior: 'smooth' }); } catch (e) { sc.scrollTop = top; }
      } else {
        try { sc.scrollTo({ top: sc.scrollHeight, behavior: 'smooth' }); } catch (e) { sc.scrollTop = sc.scrollHeight; }
      }
    });
  }

  function applyCartResponse(res) {
    if (res && res.sections && res.sections[SECTION]) swapFromHTML(res.sections[SECTION]);
    if (res && typeof res.item_count === 'number') updateBubble(res.item_count);
  }

  // ── Header-Cart-Count aktualisieren ─────────────────────────
  function updateBubble(count) {
    if (typeof count !== 'number') return;
    // VBG-Header-Badge
    var vbgBadge = document.getElementById('vbgCartBadge');
    if (vbgBadge) {
      vbgBadge.textContent = count;
      vbgBadge.style.display = count > 0 ? 'flex' : 'none';
    }
    // Dawn-Bubble (falls Theme sie nutzt)
    var bubble = document.querySelector('.cart-count-bubble');
    if (bubble) {
      var span = bubble.querySelector('span[aria-hidden="true"]');
      if (span) span.textContent = count;
      bubble.style.display = count > 0 ? '' : 'none';
    }
    document.querySelectorAll('cart-count, .cart-count').forEach(function (el) { el.textContent = count; });
    // Andere Header-Komponenten mitziehen (vbg-header lauscht darauf)
    try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
  }

  // ── Frischen Cart-Stand laden (zuverlässig via Section-Rendering
  //    auf /cart/update.js — der ?sections=-GET liefert für Layout-Sections
  //    auf Nicht-Cart-URLs keinen brauchbaren Inhalt). ──
  function refresh() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ sections: SECTION, sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(applyCartResponse).catch(function () {});
  }

  // ── Öffnen / Schließen ──────────────────────────────────────
  function doOpen() {
    lastFocus = document.activeElement;
    // Scrollbalken-Breite messen und kompensieren, damit beim Sperren des
    // Root-Scrollers (html) kein Layout-Sprung entsteht und der Drawer bündig
    // an die echte rechte Kante fährt (nicht links vom Scrollbalken).
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--vbg-sbw', (sbw > 0 ? sbw : 0) + 'px');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vbg-cd-lock');
    document.body.classList.add('vbg-cd-lock');
    var close = root.querySelector('.vbg-cd__close');
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 80);
  }
  function open() { doOpen(); refresh(); }   // z.B. Icon-Klick: öffnen + frisch laden

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vbg-cd-lock');
    document.body.classList.remove('vbg-cd-lock');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  }

  // ── Cart-Links global abfangen (Capture) → Drawer öffnen ────
  // Robust gegen unterschiedliche Header (VBG a.vbg-header-icon / a.vbg-mobile-action-btn
  // / Dawn #cart-icon-bubble): jeder Link, dessen Pfad auf /cart endet, öffnet den
  // Drawer statt zur Vollseite zu navigieren. Links IM Drawer werden nicht gekapert.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.closest('#vbgCartDrawer')) return;
    var path = (a.pathname || '').replace(/\/+$/, '');

    // Cart-Permalink /cart/{id}:{qty}[,{id}:{qty}…] → AJAX-Add + Drawer, statt zur
    // /cart-Vollseite zu navigieren. Landing-Page-CTAs nutzen genau dieses Format.
    // Checkout-Modus (data-cta-mode="checkout") wird bewusst NICHT gekapert.
    var perma = path.match(/^\/cart\/((?:\d+:\d+)(?:,\d+:\d+)*)$/);
    if (perma) {
      if (a.closest('[data-cta-mode="checkout"]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      addPermalink(perma[1]);
      return;
    }

    var isCart = a.id === 'cart-icon-bubble' || /(^|\/)cart$/.test(path);
    if (!isCart) return;
    e.preventDefault();
    if (a.id === 'cart-icon-bubble') e.stopImmediatePropagation(); // Dawn-Handler ausschalten
    open();
  }, true);

  // ── Add-to-Cart global abfangen → AJAX + Drawer öffnen ──────
  // Ersetzt den /cart-Redirect UND ein evtl. vorhandenes Upsell-Popup: unser
  // Capture-Listener läuft vor dessen Submit-Handler (Bubble) und übernimmt.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM') return;
    if (form.closest('#vbgCartDrawer')) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFormToCart(form);
  }, true);

  function addFormToCart(form) {
    if (busy) return;
    busy = true;
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', SECTION);
    fd.append('sections_url', window.location.pathname);
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function (res) {
        applyCartResponse(res);   // Drawer-Inhalt aus der Add-Antwort (enthält 'sections')
        doOpen();                 // öffnen ohne erneuten Refresh (Inhalt ist schon frisch)
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
      })
      .catch(function () { form.submit(); })   // Fallback: nativer Submit (z.B. Ausverkauft-Handling)
      .finally(function () { busy = false; if (btn) btn.classList.remove('is-loading'); });
  }

  // ── Cart-Permalink (z.B. Landing-Page-CTA /cart/123:1) → AJAX + Drawer ──
  function addPermalink(spec) {
    if (busy) return;
    busy = true;
    var items = spec.split(',').map(function (p) {
      var kv = p.split(':');
      return { id: parseInt(kv[0], 10), quantity: parseInt(kv[1], 10) || 1 };
    });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: SECTION, sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function (res) {
        applyCartResponse(res);   // Drawer-Inhalt aus der Add-Antwort (enthält 'sections')
        doOpen();                 // öffnen ohne erneuten Refresh
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
      })
      .catch(function () { window.location.href = '/cart'; })   // Fallback: Vollseite
      .finally(function () { busy = false; });
  }

  // ── Delegierte Interaktionen im Drawer ──────────────────────
  root.addEventListener('click', function (e) {
    // Schließen
    if (e.target.closest('[data-vbg-cd-close]')) {
      var isLink = e.target.closest('a[href]');
      if (!isLink) e.preventDefault();
      close();
      return;
    }

    if (busy) return;

    // Empfehlung hinzufügen
    var recoAdd = e.target.closest('.vbg-cd__reco-add');
    if (recoAdd) {
      var vid = recoAdd.getAttribute('data-variant-id');
      if (vid) cartAddVariant(vid, recoAdd);
      return;
    }

    // Entfernen (positionsunabhängig via line-item key)
    var rm = e.target.closest('.vbg-cd__item-remove');
    if (rm) {
      var li2 = rm.closest('.vbg-cd__item');
      var key2 = rm.getAttribute('data-key');
      mutate(li2, { id: key2, quantity: 0 });
      return;
    }
  });

  // ── Menge über Dropdown (DooNails-Stil) — via line-item key ──
  root.addEventListener('change', function (e) {
    if (busy) return;
    var sel = e.target.closest('.vbg-cd__qty-select');
    if (!sel) return;
    var li = sel.closest('.vbg-cd__item');
    var key = sel.getAttribute('data-key');
    var qty = parseInt(sel.value, 10);
    if (isNaN(qty) || !key) return;
    mutate(li, { id: key, quantity: qty });
  });

  function mutate(li, body) {
    busy = true;
    if (li) li.classList.add('is-loading');
    postChange(body)
      .then(applyCartResponse)
      .catch(function () {})
      .finally(function () { busy = false; });
  }

  // ── ESC schließt ────────────────────────────────────────────
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // ── Öffentliche API (für Phase 2: Add-to-Cart öffnet Drawer) ──
  window.VBGCartDrawer = {
    open: open,
    close: close,
    refresh: refresh,
    applyCartResponse: applyCartResponse
  };
})();
